import { clsx } from "clsx";
import { useTranslation } from "react-i18next";
import { Btn } from "@/ui/btn/Btn";
import { Tooltip } from "@/ui/tooltip/Tooltip";
import { createRequestDemoDialog } from "@/components/request-demo-dialog/createRequestDemoDialog";
import { useMedia } from "@/hooks/useMedia";
import { useCalculator } from "../../hooks/useCalculator";
import styles from "./CalculatorEnterprise.module.css";

export const CalculatorEnterprise: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { t } = useTranslation();
  const sm = useMedia("<sm");
  const isRequestDemoActive = useCalculator(
    (state) => state.isRequestDemoActive,
  );

  return (
    <div className={clsx(styles.enterprise, className)}>
      <div className={styles.title}>{t("enterprise.title")}</div>
      <div className={styles.text}>{t("enterprise.text")}</div>
      {isRequestDemoActive ? (
        <Btn
          text={t("enterprise.btn")}
          color="primary-light"
          size={sm ? "sm" : "md"}
          onClick={() => createRequestDemoDialog()}
        />
      ) : (
        <Tooltip>
          <Tooltip.Toggle>
            <Btn
              text={t("enterprise.btn")}
              color="primary-light"
              size={sm ? "sm" : "md"}
              disabled={true}
              onClick={() => createRequestDemoDialog()}
            />
          </Tooltip.Toggle>
          <Tooltip.Popup>{t("enterprise.notAvailable")}</Tooltip.Popup>
        </Tooltip>
      )}
    </div>
  );
};
